// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import router from './router'
import Vuetify from 'vuetify'
import Vuex from 'vuex'
import 'vuetify/dist/vuetify.min.css'
import BootstrapVue from 'bootstrap-vue'
import moment from 'vue-moment'
import loading from 'vue-loading';
// import printJs from 'print-js'
import i18n from './lang' // internationalization
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/ru-RU'
import VModal from 'vue-js-modal'
import 'element-ui/lib/theme-chalk/index.css';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import App from './App'


import './permission' // permissions

let $ = require("jquery");

import store from './store'

Vue.use(Vuetify, {
  theme: {
    primary: '#3cbc80',
    secondary: '#b0bec5',
    accent: '#8c9eff',
    error: '#b71c1c'
  }
})

Vue.use(Vuex)
Vue.use(moment)
Vue.use(VModal)
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value),
  locale
});

Vue.config.productionTip = false

import VueGoodTable from '@/components/vue-good-table'
Vue.use(VueGoodTable)

import PageTitle from '@/components/PageTitle'
Vue.component('page-title', PageTitle);

import DataTable from '@/components/DataTable'
Vue.component('data-table', DataTable);

import DataTree from '@/components/DataTree'
Vue.component('data-tree', DataTree);

import Preloader from '@/components/Preloader'
Vue.component('preloader', Preloader);

/* eslint-disable no-new */
new Vue({
  router,
  store,
  el: '#app',
  components: {
    App
  },
  directives: {
    loading
  },
  template: '<App/>'
})

$(document).ready(function () {
  $('tbody').scroll(function (e) { //detect a scroll event on the tbody
    /*
    Setting the thead left value to the negative valule of tbody.scrollLeft will make it track the movement
    of the tbody element. Setting an elements left value to that of the tbody.scrollLeft left makes it maintain 			it's relative position at the left of the table.
    */
    $('thead').css("left", -$("tbody").scrollLeft()); //fix the thead relative to the body scrolling
    $('thead th:nth-child(1)').css("left", $("tbody").scrollLeft()); //fix the first cell of the header
    $('tbody td:nth-child(1)').css("left", $("tbody").scrollLeft()); //fix the first column of tdbody
  });
});



// WEBPACK FOOTER //
// ./src/main.js